"use strict";

exports.__esModule = true;
exports["default"] = SocialTumblr;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialTumblr(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M485.5 1h-459C12.4 1 1 12.4 1 26.5v459C1 499.6 12.4 511 26.5 511h459c14 0 25.5-11.4 25.5-25.5v-459C511 12.4 499.5 1 485.5 1zM295.9 405.2c-69.4 1.2-95.9-49.4-95.9-84.9V216h-32v-40.8c49-17.4 60.1-61 62.8-85.8.2-1.7 1.6-2.4 2.4-2.4H280v81h64v48h-64v99.3c0 13.5 5 32 30.5 31.3 8.5-.2 19.7-2.7 25.6-5.5l15.2 45.4c-5.8 8.5-31.9 18.3-55.4 18.7z"
  }));
}